import * as types from './manageSubscriptionActionTypes';

// CANCEL SUBSCRIPTION
export const cancelSubscription = (subscriptionId, message) => ({
  type: types.CANCEL_SUBSCRIPTION,
  subscriptionId,
  message,
});

export const setCancelSubscriptionWaiting = (value) => ({
  type: types.SET_CANCEL_SUBSCRIPTION_WAITING,
  value,
});

export const setCancelSubscriptionSuccess = (value) => ({
  type: types.SET_CANCEL_SUBSCRIPTION_SUCCESS,
  value,
});

export const setCancelSubscriptionMessage = (message) => ({
  type: types.SET_CANCEL_SUBSCRIPTION_MESSAGE,
  message,
});

// REVERT CANCELLATION
export const revertCancellation = (subscriptionId) => ({
  type: types.REVERT_CANCELLATION,
  subscriptionId,
});

export const setRevertCancellationWaiting = (value) => ({
  type: types.SET_REVERT_CANCELLATION_WAITING,
  value,
});

export const setRevertCancellationSuccess = (value) => ({
  type: types.SET_REVERT_CANCELLATION_SUCCESS,
  value,
});

export const setRevertCancellationMessage = (message) => ({
  type: types.SET_REVERT_CANCELLATION_MESSAGE,
  message,
});

// SWITCH TO STRIPE SUBSCRIPTION
export const switchSubscriptionToStripe = (switchSubscription) => ({
  type: types.SWITCH_TO_STRIPE_SUBSCRIPTION,
  switchSubscription,
});

export const cancelScheduleIosStripeSwitch = () => ({
  type: types.CANCEL_SCHEDULE_ON_SWITCH_IOS_STRIPE,
});

// RENEW SUBSCRIPTION
export const renewSubscription = (newSubscription) => ({
  type: types.RENEW_SUBSCRIPTION,
  newSubscription,
});

// CHANGE SUBSCRIPTION
export const changeSubscription = (id, subscription) => ({
  type: types.CHANGE_SUBSCRIPTION,
  id,
  subscription,
});

// ACTIVATE SUBSCRIPTION
export const activateSubscription = () => ({
  type: types.ACTIVATE_SUBSCRIPTION,
});
export const setSubscriptionActivationWaiting = (value) => ({
  type: types.SET_SUBSCRIPTION_ACTIVATION_WAITING,
  value,
});

export const setSubscriptionActivationSuccess = (value) => ({
  type: types.SET_SUBSCRIPTION_ACTIVATION_SUCCESS,
  value,
});

export const setSubscriptionActivationMessage = (message) => ({
  type: types.SET_SUBSCRIPTION_ACTIVATION_MESSAGE,
  message,
});

// UPDATE SUBSCRIPTION PLAN
export const updateSubscriptionPlan = (planId) => ({
  type: types.UPDATE_SUBSCRIPTION_PLAN,
  planId,
});

export const setUpdateSubscriptionPlanWaiting = (value) => ({
  type: types.SET_UPDATE_SUBSCRIPTION_PLAN_WAITING,
  value,
});

export const setUpdateSubscriptionPlanSuccess = (value) => ({
  type: types.SET_UPDATE_SUBSCRIPTION_PLAN_SUCCESS,
  value,
});

export const setUpdateSubscriptionPlanMessage = (message) => ({
  type: types.SET_UPDATE_SUBSCRIPTION_PLAN_MESSAGE,
  message,
});
export const setRefundAmountMessage = (message) => ({
  type: types.SET_REFUND_AMOUNT_MESSAGE,
  message,
});

// UPGRADE SUBSCRIPTION
export const upgradeSubscription = (newSubscription) => ({
  type: types.UPGRADE_SUBSCRIPTION,
  newSubscription,
});

// GENERAL
export const setSubscriptionOperationWaiting = (value) => ({
  type: types.SET_SUBSCRIPTION_OPERATION_WAITING,
  value,
});

export const setSubscriptionOperationSuccess = (value) => ({
  type: types.SET_SUBSCRIPTION_OPERATION_SUCCESS,
  value,
});

export const setSubscriptionOperationMessage = (message) => ({
  type: types.SET_SUBSCRIPTION_OPERATION_MESSAGE,
  message,
});

export const resetComponent = () => ({
  type: types.RESET_COMPONENT,
});
